export const AnnualReferenceNumberInstructions = () => (
    <>
        <i>Where can I find my reference number?</i> <br />
        {/* If you received a letter in the mail: Top right corner box under the barcode. <br /> */}
        If you received a letter in the mail: This number can be found on your letter where it says "Reference ID". <br />
        If you received an email: Center box, below your business name & notice date.
    </>
)

export const TermsAndConditionAcceptText = () => {
    return (
        <>
            I have read, understand, and agree to be bound by the&nbsp;
            <a className="link-text" target="_blank" href="/refund-policy/" >refund policy</a>,&nbsp;
            <a className="link-text" target="_blank" href="/privacy-policy/" >privacy policy</a>,&nbsp;
            and <a className="link-text" target="_blank" href="/terms-of-service/" >terms of service</a>.&nbsp;
            I am aware that all payments are final, with the exceptions specified in the return policy.
        </>
    )
}